// extracted by mini-css-extract-plugin
module.exports = {"social":"social-module--social--1wnfE","link":"social-module--link--27OoN"};